/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1646
 */

require(/* 534 */"./1282/534")(Math, "Math", true)
